import axios, { AxiosResponse } from 'axios'
import nookies from 'nookies'

const api_url = process.env.NEXT_PUBLIC_API_URL

let config = {}
const token = nookies.get(null, 'session')
if (token) {
  config = {
    headers: {
      Authorization: 'Bearer ' + token.session,
    },
  }
}

export interface Manufacturer {
  id: number
  name: string
  email: string
}

export const getManufacturers = async (): Promise<Manufacturer[]> => {
  const response = await axios.get<AxiosResponse<Manufacturer[]>>(api_url + `/manufacturer/`, config)
  const { data } = response.data
  return data
}

export default {
  getManufacturers,
}
